$(document).ready(function () {
  if($(".filter-wr .sidebar-tag .content .widget-content").find("input:checked").length){
    return;
  }else if($("body").hasClass("mobile")){
    pdlistGrid();
  }else{
    init();
    pdRandom();
    hideBefore();
    pdlistGrid();

  }
});

function hideBefore(){
  $(".collection-page").addClass("show_after");
}

function pdlistGrid(){
  var gridItem = $(".colection_gutter .collection-page .products-grid.product-grid-item > div")
  var itemIndex = gridItem.eq();
//   console.log(itemIndex);
//   console.log(gridItem.length);
  var i;
  for(i = 1 ; i<=gridItem.length; i++ ){ 
    if(i%3==0){
//       console.log(i);
    } 
  }
}

function init(){
  var rd_pos,
      rd_pos2,
      rd_pos3,
      i,
      j,
      k,
      l = 0;

  var $parent,
      $child,
      $group,
      $group2,
      $rd_img,
      $rd_img2,
      $rd_img3,
      $rd_img4,
      $rd_img6,
      $rd_img7,
      $rd_img8,
      $rd_img22,
      $rd_img222,
      $rd_img2222,
      $rd_img22222,
      colName,
      $rdImg,
      $rdImg2,
      imgURLs,
      imgURLs2,
      $check = null;
};

function pdRandom($check){
  if($("body").hasClass("tablet")){
    $check = "z";
  }else{
    $check = "y";
  }
  
  colName = $("body").attr("id");
  colTag = window.location.pathname;
  //colTag = colTag.replace('/collections/','')
  
  if((colTag.indexOf("lapel-flower") != -1)&& (colTag.length > 25)){
//     colTag = colTag.replace('/collections/lapel-flower','')
   // console.log(colTag)
    return
  }
  
  
  if(colName.includes("cosa-")){
    colName = colName.replace("cosa-",'');
  }

  // under5
  if(colName == "blanc"){ 
    under5(colName,$check); 
  }

  // under10
  if((colName == "rispetto")||(colName == "glorio")){
    under10(colName,$check); 
  };

  // under14
  if((colName == "compagnia")||(colName == "brama")||(colName == "fama")||(colName == "talento")||(colName == "bravado")||(colName == "vivido")){
    under21(colName,$check);
  };
  
  if((colName =="piora")||(colName =="lapel-flower")){
    over21(colName, $check);
  };
  
};


// position
function under5(colName,$check){
  $parent = $(".product-grid-item");
  $child = $parent.children();

  $rd_img = $("<div class='pd_random pd_small col-lg-3 col-md-4 col-6 product-items'></div>");

//   console.log($check);
  // Cosa Blanc
  if($check== "y"){
    rd_pos = RdInt(0,2);
  }else if($check =="z"){
    rd_pos = RdInt(5,7);
  };
  
  if(rd_pos == 0){
    // A set
    $rd_img.insertBefore($child.eq(3));
  }else if(rd_pos == 1){
    // B set
    $rd_img.insertAfter($child.eq(4));
  }else if(rd_pos == 5){
    // A set
    $rd_img.insertAfter($child.eq(1));
  }else if(rd_pos == 6){
    // B set
    $rd_img.insertAfter($child.eq(4));                  
  };

  // img set
  getImgD(colName,rd_pos); 
  
  // check colName + pos number
  // console.log(colName);
  // console.log("pos="+rd_pos); 

};


function under10(colName,$check){
  $parent = $(".product-grid-item");
  $child = $parent.children();

  //$rd_img = $("<div class='col-lg-3 col-md-4 col-6 product-items'><div class='pd_random pd_small'></div></div>");
  $rd_img = $("<div class='pd_random pd_small col-lg-3 col-md-4 col-6 product-items'></div>");
  $rd_img2 = $("<div class='pd_random pd_medium col-lg-6 col-md-8 col-6'></div>");

//   console.log($check);
  if(colName == "glorio"){
    // Glorio
    if($check== "y"){
      rd_pos = RdInt(0,2);
    }else if($check =="z"){
      rd_pos = RdInt(5,7);
    };
    
    if(rd_pos == 0){
      // A set
      $rd_img.insertBefore($child.eq(0));
      $rd_img2.insertBefore($child.eq(5));

    }else if(rd_pos == 1){
      // B set
      $rd_img2.insertBefore($child.eq(2));
      $rd_img.insertBefore($child.eq(2));
      
    }else if(rd_pos == 5){
      // A set
      $rd_img.insertAfter($child.eq(2));
      
    }else if(rd_pos == 6){
      // B set
      $rd_img.insertAfter($child.eq(1));
      
    };
    
    // img set
    getImgC(colName,rd_pos);
    
    // check colName + pos number
//     console.log(colName);
//     console.log("pos="+rd_pos);

  }else if(colName == "rispetto"){
    // Rispetto
    if($check== "y"){
      rd_pos = RdInt(0,3);
    }else if($check =="z"){
      rd_pos = RdInt(5,8);
    };

    if(rd_pos == 0){
      // A set
      $rd_img2.insertBefore($child.eq(2));
      $rd_img.insertBefore($child.eq(2));

    }else if(rd_pos == 1){
      // B set
      $rd_img.insertAfter($child.eq(6));
      $rd_img2.insertBefore($child.eq(2));
      
    }else if(rd_pos == 2){
      // C set
      $rd_img.insertBefore($child.eq(0));
      $rd_img2.insertBefore($child.eq(5));
      
    }else if(rd_pos == 5){
      // A set
      $rd_img.insertAfter($child.eq(4)); 
      
    }else if(rd_pos == 6){
      // B set
      $rd_img.insertAfter($child.eq(1));
      
    }else if(rd_pos == 7){
      // C set
      $rd_img.insertAfter($child.eq(6));
      
    };

    // img set
    if((rd_pos == 2)||(rd_pos == 7)){
      getImgB(colName,rd_pos);
    }else{
      getImgC(colName,rd_pos);
    }
    
    // check colName + pos number
//     console.log(colName);
//     console.log("pos="+rd_pos); 


  };
};



function under21(colName,$check){
  $parent = $(".product-grid-item");
  $child = $parent.children();

  $rd_img = $("<div class='pd_random pd_small col-lg-3 col-md-4 col-6 product-items'></div>");
  $rd_img2 = $("<div class='pd_random pd_medium col-lg-6 col-md-8 col-6'></div>");
  $rd_img3 = $("<div class='pd_random pd_small pd_small2 col-lg-3 col-md-4 col-6 product-items'></div>");

  if($check== "y"){
    rd_pos = RdInt(0,3);
  }else if($check =="z"){
    rd_pos = RdInt(5,8);
  }; 
  // Talento   
  if(colName == "talento"){ 
    if(rd_pos == 0){
      // A set  

      // 2x1 img position
      bigPos(4,0);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(5));
      $rd_img2.insertAfter($child.eq(9));

    }else if(rd_pos == 1){
      // B set

      // 2x2 img position
      bigPos(5,6);

      // 1x1, 2x1 img position
      $rd_img.insertAfter($child.eq(4));
      $rd_img2.insertBefore($child.eq(0));

    }else if(rd_pos == 2){
      // C set

      // 2x2 img position
      bigPos(9,5);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(2));
      $rd_img2.insertAfter($child.eq(1));

    }else if(rd_pos == 5){
      // A set
      $rd_img.insertAfter($child.eq(1));
      $rd_img2.insertBefore($child.eq(5));

    }else if(rd_pos == 6){
      // B set
      $rd_img.insertAfter($child.eq(5));
      $rd_img2.insertBefore($child.eq(0));

    }else if(rd_pos == 7){
      // C set
      $rd_img.insertAfter($child.eq(11));
      $rd_img2.insertBefore($child.eq(6));

    }
    
    if((rd_pos == 2)||(rd_pos == 7)){
      getImgA(colName,rd_pos);
    }else{
      getImgB(colName,rd_pos);
    }

    // check colName + pos number
//     console.log($check);
//     console.log(colName);
//     console.log("pos="+rd_pos); 

  }else if(colName == "brama"){
    // Cosa Brama
    if(rd_pos == 0){
      // A set  

      // 2x1 img position
      bigPos(9,5);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(2));
      $rd_img2.insertAfter($child.eq(1));

    }else if(rd_pos == 1){
      // B set

      // 2x2 img position
      bigPos(5,6);

      // 1x1, 2x1 img position
      $rd_img.insertAfter($child.eq(4));
      $rd_img2.insertBefore($child.eq(0));

    }else if(rd_pos == 2){
      // C set

      // 2x2 img position
      bigPos(4,0);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(5));
      $rd_img2.insertAfter($child.eq(9));

    }else if(rd_pos == 5){
      // A set
      $rd_img.insertBefore($child.eq(0));
      $rd_img2.insertAfter($child.eq(5));

    }else if(rd_pos == 6){
      // B set
      $rd_img.insertBefore($child.eq(4));
      $rd_img2.insertAfter($child.eq(0));

    }else if(rd_pos == 7){
      // C set
      $rd_img.insertBefore($child.eq(10));
      $rd_img2.insertAfter($child.eq(6));

    };
    
    // img set
      getImgB(colName,rd_pos);

    // check colName + pos number
//     console.log(colName);
//     console.log("pos="+rd_pos); 

  }else if(colName == "fama"){
    // Fama 
    if(rd_pos == 0){
      // A set  

      // 2x1 img position
      bigPos(4,0);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(5));
      $rd_img2.insertAfter($child.eq(9));

    }else if(rd_pos == 1){
      // B set

      // 2x2 img position
      bigPos(9,5);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(2));
      $rd_img2.insertAfter($child.eq(1));

    }else if(rd_pos == 2){
      // C set

      // 2x2 img position
      bigPos(10,6);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(11));
      $rd_img2.insertBefore($child.eq(0));

    }else if(rd_pos == 5){
      // A set
      $rd_img.insertBefore($child.eq(0));
      $rd_img2.insertBefore($child.eq(6));

    }else if(rd_pos == 6){
      // A set
      $rd_img.insertBefore($child.eq(2));
      $rd_img2.insertBefore($child.eq(8));

    }else if(rd_pos == 7){
      // A set
      $rd_img.insertBefore($child.eq(7));
      $rd_img2.insertBefore($child.eq(4));

    };

    // img set
    if((rd_pos == 2)||(rd_pos == 7)){
      getImgA(colName,rd_pos);
    }else{
      getImgB(colName,rd_pos);
    }
    
    // check colName + pos number
//     console.log(colName);
//     console.log("pos="+rd_pos); 

  }else if(colName == "compagnia"){
    // Compagnia 
    if(rd_pos == 0){
      // A set  

      // 2x1 img position
      bigPos(4,0);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(5));
      $rd_img2.insertAfter($child.eq(9));

    }else if(rd_pos == 1){
      // B set

      // 2x2 img position
      bigPos(9,5);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(2));
      $rd_img2.insertAfter($child.eq(1));

    }else if(rd_pos == 2){
      // C set

      // 2x2 img position
      bigPos(9,10);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(0));
      $rd_img2.insertBefore($child.eq(5));

    }else if(rd_pos == 5){
      // A set
      $rd_img.insertBefore($child.eq(2));
      $rd_img2.insertBefore($child.eq(5));

    }else if(rd_pos == 6){
      // A set
      $rd_img.insertBefore($child.eq(2));
      $rd_img2.insertBefore($child.eq(9));

    }else if(rd_pos == 7){
      // A set
      $rd_img.insertBefore($child.eq(9));
      $rd_img2.insertBefore($child.eq(3));

    };

    // img set
    if((rd_pos == 2)||(rd_pos == 7)){
      getImgA(colName,rd_pos);
    }else{
      getImgC(colName,rd_pos);
    }
    
    // check colName + pos number
//     console.log(colName);
//     console.log("pos="+rd_pos); 
    
    

  }else if(colName == "bravado"){
    // Bravado
    if(rd_pos == 0){
      // A set  

      // 2x1 img position
      bigPos(4,0);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(5));
      $rd_img2.insertAfter($child.eq(9));

      // img set
      getImgC(colName,rd_pos);
    }else if(rd_pos == 1){
      // B set

      // 2x2 img position
      bigPos(9,10);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(0));
      $rd_img2.insertBefore($child.eq(5));

      // img set
      getImgA(colName,rd_pos);
    }else if(rd_pos == 2){
      // C set

      // 2x2 img position
      bigPos(4,0);

      // 1x1, 2x1 img position
      $rd_img.insertAfter($child.eq(8));
      $rd_img2.insertAfter($child.eq(13));

      // img set
      getImgB(colName,rd_pos);
    }else if(rd_pos == 5){
      // A set
      $rd_img.insertBefore($child.eq(0));
      $rd_img2.insertAfter($child.eq(5));
      $rd_img3.insertAfter($child.eq(11));

      // img set
      getImgE(colName,rd_pos,$check);
    }else if(rd_pos == 6){
      // B set
      $rd_img.insertBefore($child.eq(2));
      $rd_img2.insertAfter($child.eq(9));
      $rd_img3.insertAfter($child.eq(4));

      // img set
      getImgF(colName,rd_pos,$check);
      
    }else if(rd_pos == 7){
      // C set
      $rd_img.insertBefore($child.eq(0));
      $rd_img2.insertAfter($child.eq(9));
      $rd_img3.insertAfter($child.eq(3));

      // img set
      getImgF(colName,rd_pos,$check);
    };

    // check colName + pos number
//     console.log(colName);
//     console.log("pos="+rd_pos); 

  }else if(colName == "vivido"){
    // vivido
    if(rd_pos == 0){
      // A set  

      // 2x2 img position
      bigPos(9,10);

      // 1x1, 2x1 img position
      $rd_img.insertAfter($child.eq(4));
      $rd_img2.insertBefore($child.eq(0));

      // img set
      getImgB(colName,rd_pos);
    }else if(rd_pos == 1){
      // B set

      // 2x1 img position
      bigPos(4,0);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(5));
      $rd_img2.insertAfter($child.eq(9));

      // img set
      getImgB(colName,rd_pos);
    }else if(rd_pos == 2){
      // C set

      // 2x2 img position
      bigPos(13,9);

      // 1x1, 2x1 img position
      $rd_img.insertAfter($child.eq(2));
      $rd_img2.insertBefore($child.eq(3));

     
    }else if(rd_pos == 5){
      // A set
      $rd_img.insertAfter($child.eq(2));
      $rd_img2.insertAfter($child.eq(8));
      $rd_img3.insertAfter($child.eq(13));

      // img set
      getImgG(colName,rd_pos,$check);
    }else if(rd_pos == 6){
      // A set
      $rd_img.insertAfter($child.eq(1));
      $rd_img2.insertAfter($child.eq(9));
      $rd_img3.insertAfter($child.eq(4));

      // img set 
      getImgH(colName,rd_pos,$check);
    }else if(rd_pos == 7){
      // A set
      $rd_img.insertAfter($child.eq(4));
      $rd_img2.insertAfter($child.eq(12));
      $rd_img3.insertAfter($child.eq(7));
      
      // img set
      getImgG(colName,rd_pos,$check);
    };

    if((rd_pos < 3)){
    // img set
      getImgB(colName,rd_pos);
    }


    // check colName + pos number
//     console.log(colName);
//     console.log("pos="+rd_pos); 
  };
};


function over21(colName,$check){
  $parent = $(".product-grid-item");
  $child = $parent.children();

  $rd_img = $("<div class='pd_random pd_small col-lg-3 col-md-4 col-6 product-items'></div>");
  $rd_img2 = $("<div class='pd_random pd_medium col-lg-6 col-md-8 col-6'></div>");
  $rd_img3 = $("<div class='pd_random pd_small pd_small2 col-lg-3 col-md-4 col-6 product-items'></div>");

  
  if($check== "y"){
    rd_pos = RdInt(0,2);
//     rd_pos = 1; 
  }else if($check =="z"){
    rd_pos = RdInt(5,7);
//     rd_pos = 6;
  }; 
  
  // rd_pos=0;
    if(rd_pos == 0){
      // A set  
      
      // 2x1 img position
      bigPos(4,0);
      
      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(5));
      $rd_img2.insertAfter($child.eq(9));
      
      // img set
      getImgI(rd_pos);
    }else if(rd_pos == 1){
      // B set

      // 2x1 img position
      bigPos(9,10);

      // 1x1, 2x1 img position
      $rd_img.insertBefore($child.eq(0));
      $rd_img2.insertBefore($child.eq(5));

      // img set
      getImgI(rd_pos);
    }else if(rd_pos == 5){
      $rd_img.insertAfter($child.eq(2));
      $rd_img3.insertAfter($child.eq(9));
      $rd_img2.insertAfter($child.eq(12));
      
      // img set
      getImgJ(rd_pos,colName,$check);
    }else if(rd_pos == 6){
      $rd_img.insertBefore($child.eq(0));
      $rd_img3.insertAfter($child.eq(13));
      $rd_img2.insertAfter($child.eq(5));
      
//       getImgJ2(colName,$check);
      getImgJ(rd_pos,colName,$check);
    }
    
  
//   console.log($check);
//   console.log(colName);
//   console.log("pos="+rd_pos); 

};


function getImgI(rd_pos,colName){
  // change num to ABC
  if((rd_pos == 0)||(rd_pos == 5)){
    rd_pos = "A"
  }else if((rd_pos == 1)||(rd_pos == 6)){
    rd_pos = "B"
  };
  
  if(rd_pos == "A"){
    // 1-1x1
    imgURLs= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A2.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B2.png"
    ];

    // 2-2x1
    imgURLs2= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_A1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_B1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_C1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_C2.png"
    ];
  }else if(rd_pos == "B"){
    // 1-1x1
    imgURLs= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A2.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B2.png"
    ];

    // 2-2x1
    imgURLs2= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_glorio_A1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_glorio_B1.png"
    ];
  }

  // set img function
  imgset(colName);
  
}

    
function getImgJ(rd_pos,colName,$check){
  // change num to ABC
  if(rd_pos == 5){

    // 1x1
    imgURLs= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A2.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B2.png"
    ];

    // 2X1
    imgURLs2= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_vivido_A1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_vivido_B1.png",
    ];


    // 1X1
    imgURLs3= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_rispetto_A1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_rispetto_A2.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_rispetto_B2.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_rispetto_C1.png"
    ];
  }else if(rd_pos == 6){
    // 1x1
    imgURLs= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A2.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B2.png"
    ];

    // 2X1
    imgURLs2= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_A1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_B1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_C1.png"
    ];


    // 1X1
    imgURLs3= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_A1.png",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_C1.png"
    ];
  }

  // set img function
  imgset(colName,$check);

}

function getImgJ2(colName,$check){
  // 1x1
  imgURLs= [
        "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A1.png",
        "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_A2.png",
        "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B1.png",
    	"https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_glorio_B2.png"
  ];

  // 2X1
  imgURLs2= [
        "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_A1.png",
        "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_B1.png",
        "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_rispetto_C1.png"
  ];


  // 1X1
  imgURLs3= [
        "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_B1.png",
        "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_vivido_C1.png"
  ];

  // set img function
  imgset(colName,$check);

}    


    

// img 
function getImgA(colName,rd_pos){
  // change num to ABC
  if((rd_pos == 0)||(rd_pos == 5)){
    rd_pos = "A"
  }else if((rd_pos == 1)||(rd_pos == 6)){
    rd_pos = "B"
  }else if((rd_pos == 2)||(rd_pos == 7)){
    rd_pos = "C"
  }

  // 1x1
  imgURLs= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"1.png?54664"
  ];

  // 2x1
  imgURLs2= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"1.png?54664",
  ];

  // set img function
  imgset(colName);
};

function getImgB(colName,rd_pos){
  // change num to ABC
  if((rd_pos == 0)||(rd_pos == 5)){
    rd_pos = "A"
  }else if((rd_pos == 1)||(rd_pos == 6)){
    rd_pos = "B"
  }else if((rd_pos == 2)||(rd_pos == 7)){
    rd_pos = "C"
  }

  // 1x1
  if(colName == "vivido"){
    imgURLs= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"1.png?54664",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"2.png?54664"
    ];

  }else{
    imgURLs= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"1.png?54664"
    ];
  }

    // 2x1
    imgURLs2= [
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"1.png?54664",
      "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"2.png?54664"
    ];

  // set img function
  imgset(colName);
};

function getImgC(colName,rd_pos){
  // change num to ABC
  if((rd_pos == 0)||(rd_pos == 5)){
    rd_pos = "A"
  }else if((rd_pos == 1)||(rd_pos == 6)){
    rd_pos = "B"
  }else if((rd_pos == 2)||(rd_pos == 7)){
    rd_pos = "C"
  }

  // 1x1
  imgURLs= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"1.png?54664",
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"2.png?54664"
  ];

  // 2x1
  imgURLs2= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"1.png?54664"
  ];

  // set img function
  imgset(colName);
};

function getImgD(colName,rd_pos){  
  if((rd_pos == 0)||(rd_pos == 5)){
    rd_pos = "A"
   }else if((rd_pos == 1)||(rd_pos == 6)){
    rd_pos = "B"
  }
  
  // 1x1
  imgURLs= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"1.png?54664",
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"2.png?54664",
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"3.png?54664"
  ];

  // set img function
  imgset(colName);
};

function getImgE(colName,rd_pos,$check){
  // change num to ABC
  if((rd_pos == 0)||(rd_pos == 5)){
    rd_pos = "A"
  }else if((rd_pos == 1)||(rd_pos == 6)){
    rd_pos = "B"
  }else if((rd_pos == 2)||(rd_pos == 7)){
    rd_pos = "C"
  }

  // 1x1
  imgURLs= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"1.png?54664",
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"2.png?54664"
  ];

  // 2x1
  imgURLs2= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"1.png?54664"
  ];
  
  // 1x1
  imgURLs3= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_T_C2.png?93416"
//     "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"3.png?54664"
  ];

  // set img function
  imgset(colName,$check);
}

function getImgF(colName,rd_pos,$check){
  // change num to ABC
  if((rd_pos == 0)||(rd_pos == 5)){
    rd_pos = "A"
  }else if((rd_pos == 1)||(rd_pos == 6)){
    rd_pos = "B"
  }else if((rd_pos == 2)||(rd_pos == 7)){
    rd_pos = "C"
  }

  // 1x1
  imgURLs= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_T_"+rd_pos+"1.png?934164"
  ];

  // 2x1
  if(rd_pos == "B"){
    imgURLs2= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"1.png?934164"
  ];
  }else{
    imgURLs2= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"1.png?934164",
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"2.png?934164"
  ];
  }
  
  
  
  // 1x1
  imgURLs3= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_T_"+rd_pos+"2.png?95193"
//     "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"3.png?54664"
  ];

  // set img function
  imgset(colName,$check);
}

function getImgG(colName,rd_pos,$check){
  // change num to ABC
  if((rd_pos == 0)||(rd_pos == 5)){
    rd_pos = "A"
  }else if((rd_pos == 1)||(rd_pos == 6)){
    rd_pos = "B"
  }else if((rd_pos == 2)||(rd_pos == 7)){
    rd_pos = "C"
  }
  
  // 1x1
  imgURLs= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"1.png?934164",
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"2.png?934164"
  ];

  // 2x1
  imgURLs2= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"2.png?93887",
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"3.png?93887"
  ];
  
  // 1x1
  imgURLs3= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"1.png?934164"
  ];
  
  // set img function
  imgset(colName,$check);
}

function getImgH(colName,rd_pos,$check){
  // change num to ABC
  if((rd_pos == 0)||(rd_pos == 5)){
    rd_pos = "A"
  }else if((rd_pos == 1)||(rd_pos == 6)){
    rd_pos = "B"
  }else if((rd_pos == 2)||(rd_pos == 7)){
    rd_pos = "C"
  }
  
  // 1x1
  imgURLs= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_A1.png?934164"
  ];

  // 2x1
  imgURLs2= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"1.png?93887",
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/2x1_"+colName+"_"+rd_pos+"2.png?93887"
  ];
  
  // 1x1
  imgURLs3= [
    "https://cdn.shopify.com/s/files/1/0213/5710/1156/files/1x1_"+colName+"_"+rd_pos+"1.png?934164"
  ];
  
  // set img function
  imgset(colName,$check);
}




function imgset(colName,$check){
  $rdImg = $(".pd_small");
  $rdImg2 = $(".pd_medium");
  $rdImg3 = $(".pd_small2");

  $.each($rdImg, function(index, element){
    displayImg(element);
  });

  function displayImg(element){
    var randomIndex = Math.floor(Math.random()*imgURLs.length);
    $(element).css({
      "background-image" : "url("+ imgURLs[randomIndex]+")"
    });

  };

  if(colName != "blanc"){
    $.each($rdImg2, function(index, element){
      displayImg2(element);
    });
    
    function displayImg2(element){
      var randomIndex = Math.floor(Math.random()*imgURLs2.length);
      $(element).css({
        "background-image" : "url("+ imgURLs2[randomIndex]+")"
      });
    };
    
    if($check == "z"){
      $.each($rdImg3, function(index, element){
        displayImg3(element);
      });
      
      function displayImg3(element){
        var randomIndex = Math.floor(Math.random()*imgURLs3.length);
        $(element).css({
          "background-image" : "url("+ imgURLs3[randomIndex]+")"
        });
      };
    }
    
   
    
    function displayImg4(element){
      var randomIndex = Math.floor(Math.random()*imgURLs4.length);
      $(element).css({
        "background-image" : "url("+ imgURLs4[randomIndex]+")"
      });
    };
  }
}


function RdInt(min, max) {
  var min = Math.ceil(min);
  var max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
};


function bigPos(k,j){  
  // 1st img

  $child.eq(k).before("<div class='pd_group col-lg-6 col-md-8 col-6 product-items'></div>");
  $group = $(".pd_group")
  $child.eq(k).appendTo($group);
  $child.eq(k).removeClass("col-lg-3 col-md-4 col-6");

  // !important : 추후 꼭 모바일기기의 반응형코드를 작성할것

  $child.eq(j).before("<div class='pd_group2 col-lg-6 col-md-12 col-6'></div>");
  $group2 = $(".pd_group2");

  var i;
  for (i=j; i<(j+4); i++){
    $child.eq(i).appendTo($group2);
//     $child.eq(i).appendTo(".products-grid")
    $child.eq(i).removeClass("col-lg-3 col-md-4");
    $child.eq(i).addClass("col-lg-6 col-md-4 col-6");
    $child.eq(i).css("float","left");
  }
  
  
};


function bigPos2(k,j){  
  // 1st img

  $child.eq(k).before("<div class='pd_group3 col-lg-6 col-md-8 col-6 product-items'></div>");
  $group = $(".pd_group3")
  $child.eq(k).appendTo($group);
  $child.eq(k).removeClass("col-lg-3 col-md-4 col-6");

  // !important : 추후 꼭 모바일기기의 반응형코드를 작성할것

  $child.eq(j).before("<div class='pd_group4 col-lg-6 col-md-12 col-6'></div>");
  $group2 = $(".pd_group4");

  var i;
  for (i=j; i<(j+4); i++){
    $child.eq(i).appendTo($group2);
//     $child.eq(i).appendTo(".products-grid")
    $child.eq(i).removeClass("col-lg-3 col-md-4");
    $child.eq(i).addClass("col-lg-6 col-md-4 col-6");
    $child.eq(i).css("float","left");
  }
  
  
};

function bigPos3(k,j){  
  // 1st img

  $child.eq(k).before("<div class='pd_group5 col-lg-6 col-md-8 col-6 product-items'></div>");
  $group = $(".pd_group5")
  $child.eq(k).appendTo($group);
  $child.eq(k).removeClass("col-lg-3 col-md-4 col-6");

  // !important : 추후 꼭 모바일기기의 반응형코드를 작성할것

  $child.eq(j).before("<div class='pd_group6 col-lg-6 col-md-12 col-6'></div>");
  $group2 = $(".pd_group6");

  var i;
  for (i=j; i<(j+4); i++){
    $child.eq(i).appendTo($group2);
//     $child.eq(i).appendTo(".products-grid")
    $child.eq(i).removeClass("col-lg-3 col-md-4");
    $child.eq(i).addClass("col-lg-6 col-md-4 col-6");
    $child.eq(i).css("float","left");
  }
  
  
};

